import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import * as _ from 'lodash';

@Pipe({
  name: 'bcacPipe'
})
export class BcacPipe implements PipeTransform {

  transform(value: any, type: string): any {
    if (!_.isNil(value) && value != -99 && value != "-99" && value != "null") {
      switch (type) {
        case "year":
          if(value instanceof Date) {
            return new DatePipe("en-US").transform(value, "yyyy");
          } else {
            return new DatePipe("en-US").transform(new Date(value), "yyyy");
          }
        case "month":
          if(value instanceof Date) {
            return new DatePipe("en-US").transform(value, "yyyy-MM");
          } else {
            return new DatePipe("en-US").transform(new Date(value), "yyyy-MM");
          }
        case "date":
          if(value instanceof Date) {
            return new DatePipe("en-US").transform(value, "yyyy-MM-dd");
          } else {
            return new DatePipe("en-US").transform(new Date(value), "yyyy-MM-dd");
          }
        case "date-time":
          if(value instanceof Date) {
            return new DatePipe("en-US").transform(value, "yyyy-MM-dd HH:mm:ss");
          } else {
            return new DatePipe("en-US").transform(new Date(value), "yyyy-MM-dd HH:mm:ss");
          }
        case "time":
          if(value instanceof Date) {
            return new DatePipe("en-US").transform(value, "HH:mm:ss");
          } else {
            return new DatePipe("en-US").transform(new Date(value), "HH:mm:ss");
          }
        case "number":
          return Number(value).toFixed(0);
        case "number1":
          return Number(value).toFixed(1);
        case "number2":
          return Number(value).toFixed(2);
        default:
          return value;
      }
    } else {
      return "--";
    }
  }

}
